import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAlert } from 'react-alert';
import { APIURL, TZ } from "../../../Global";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
function Notes(props) {
  const [login_datas, setLogin_datas] = useState(
    JSON.parse(sessionStorage.getItem("logindatas")) || null
  );
  const alert = useAlert();
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [note, setNote] = useState("")
  const [isAdd, setIsAdd] = useState(false)
  const [isModify, setIsModify] = useState(false)
  const [mID, setMid] = useState("")
  const [lastUserItemId, setlastUserItemId] = useState(null)
  useEffect(() => {

    const tokenString = sessionStorage.getItem('usertoken');
    const usertype = sessionStorage.getItem('usertype');
    let str = tokenString.replace(/["]+/g, '')


    axios.get(`${APIURL}/api/v1/staff/hospital-details-notes/?requested_user=${usertype}&hospital_id=${props.id}&${TZ}`, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res => {

        if (res.data.status === "success") {
          let notes = res.data.data.reverse()
          setData(notes)
          if (res.data.data.length === 0) {
            setIsAdd(true)


          }
          setlastUserItemId([...notes].find(item => item.created === login_datas.name)?.id)

        }


      })
      .catch(err => {

      })


  }, [refresh]);
  const handleSave = () => {

    const id = props.id;
    const tokenString = sessionStorage.getItem("usertoken");

    let str = tokenString.replace(/["]+/g, "");
    let lic = []

    const dataToUpdate = {
      "hospital_id": props.id,
      "notes": note
    };


    axios
      .post(`${APIURL}/api/v1/staff/hospital-details-notes/`, dataToUpdate, {
        headers: {
          Authorization: "Token " + str,
          "Content-Type": "application/json",
        },
      })

      .then((res) => {

        if (res.data.status === "success") {
          alert.success(res.data.message)
          setIsAdd(false)
          setNote("")
          setRefresh(!refresh)


        } else {
          alert.error(res.data.message);
        }
      })
      .catch((err) => {
        alert.error("error in submission")
      });

  };
  const handleDelete = (modified) => {


    const tokenString = sessionStorage.getItem("usertoken");

    let str = tokenString.replace(/["]+/g, "");


    const dataToUpdate = {

      is_deleted: true,
      id: modified.id,
    };


    axios
      .put(`${APIURL}/api/v1/staff/hospital-details-notes/`, dataToUpdate, {
        headers: {
          Authorization: "Token " + str,
          "Content-Type": "application/json",
        },
      })

      .then((res) => {

        if (res.data.status === "success") {
          alert.success(res.data.message)
          setIsAdd(false)
          setNote("")
          setRefresh(!refresh)


        } else {
          alert.error(res.data.message);
        }
      })
      .catch((err) => {
        alert.error("error in submission")
      });

  };
  const handleModify = () => {


    const tokenString = sessionStorage.getItem("usertoken");

    let str = tokenString.replace(/["]+/g, "");


    const dataToUpdate = {

      notes: note,
      id: mID,
    };


    axios
      .put(`${APIURL}/api/v1/staff/hospital-details-notes/`, dataToUpdate, {
        headers: {
          Authorization: "Token " + str,
          "Content-Type": "application/json",
        },
      })

      .then((res) => {

        if (res.data.status === "success") {
          alert.success(res.data.message)
          setIsAdd(false)
          setNote("")
          setIsModify(false)
          setRefresh(!refresh)


        } else {
          alert.error(res.data.message);
        }
      })
      .catch((err) => {
        alert.error("error in submission")
      });

  };
  return (
    <div style={{ height: "100%" }}>
      {isAdd ? <div style={{ height: "100%" }}>
        <h6 class="" style={{ paddingLeft: "1%", textTransform: "capitalize", marginTop: "2%" }} ><b>Plan Details</b>
          <svg onClick={(e) => { setIsAdd(false); setIsModify(false); }} style={{ float: "right", marginRight: "2%" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="currentColor"><path d="M16.396 7.757a1 1 0 0 1 0 1.415l-2.982 2.981l2.676 2.675a1 1 0 1 1-1.415 1.415L12 13.567l-2.675 2.676a1 1 0 0 1-1.415-1.415l2.676-2.675l-2.982-2.981A1 1 0 1 1 9.02 7.757L12 10.74l2.981-2.982a1 1 0 0 1 1.415 0" /><path fillRule="evenodd" d="M4 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3zm16 2H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1" clipRule="evenodd" /></g></svg>
        </h6>
        <textarea style={{ height: "60%", width: "98%" }} value={note} name="official_address" type="text" className="det-div" onChange={(e) => { setNote(e.target.value) }} ></textarea>
        <button onClick={(e) => { if (note === "") { alert.error("enter notes") } else { isModify ? handleModify() : handleSave() } }
        } style={{ backgroundColor: "#55479F", width: "98%" }} className="clinic_button">{isModify ? "Update" : "Submit"}</button>
      </div>
        : <div>
          <h6 class="" style={{ paddingLeft: "1%", textTransform: "capitalize", marginTop: "2%" }} ><b>Plan Details</b>
            <button className="clinic_button" onClick={(e) => { setIsAdd(true) }} style={{ float: "right", marginRight: "2%", backgroundColor: "rgb(85, 71, 159)", marginBottom: "1%" }}>Add new</button>
          </h6>
          <SimpleBar style={{ maxHeight: "250px", width: "100%" }}>
            {data.length > 0 && data.map((item) => {
              const isEditable = item.id === lastUserItemId;

              return (
                <div key={item.id} style={{ border: "1px solid gray", borderRadius: "5px", backgroundColor: "#cbdadb4f", padding: "3%", marginBottom: "1%", width: "98%" }}>
                  <h6 className="row">
                    <div className="col-9">
                      {item.created}<br />
                      <small>
                        {(item.modified_at || item.created_at).slice(0, 10)}&nbsp;
                        {(item.modified_at || item.created_at).slice(11, 16)}
                      </small>
                    </div>

                    {isEditable && <div className="col-3">
                      {/* Edit Button */}
                      <svg
                        style={{ cursor: isEditable ? "pointer" : "not-allowed" }}
                        onClick={() => {
                          if (isEditable) {
                            setMid(item.id);
                            setNote(item.note);
                            setIsModify(true);
                            setIsAdd(true);
                          }
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                      >
                        <g fill="none" stroke="rgb(85, 71, 159)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                          <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                          <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
                        </g>
                      </svg>
                      &nbsp;

                      {/* Delete Button */}
                      <svg
                        style={{ cursor: isEditable ? "pointer" : "not-allowed", float: "right" }}
                        onClick={() => {
                          if (isEditable) {
                            handleDelete(item, "del");
                          }
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                      >
                        <g fill="red">
                          <path d="M16.396 7.757a1 1 0 0 1 0 1.415l-2.982 2.981l2.676 2.675a1 1 0 1 1-1.415 1.415L12 13.567l-2.675 2.676a1 1 0 0 1-1.415-1.415l2.676-2.675l-2.982-2.981A1 1 0 1 1 9.02 7.757L12 10.74l2.981-2.982a1 1 0 0 1 1.415 0" />
                          <path fillRule="evenodd" d="M4 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3zm16 2H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1" clipRule="evenodd" />
                        </g>
                      </svg>
                    </div>}
                  </h6>

                  <div className="container-fluid" style={{ backgroundColor: "white" }}>
                    {item.note}
                  </div>
                </div>
              );
            })}



          </SimpleBar>
        </div>}

    </div>
  );
}
export default Notes;
